import styled from "styled-components";

const AbsoluteFlex = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
`;
export default AbsoluteFlex;



// WEBPACK FOOTER //
// ./src/module-common/AbsoluteFlex.js